import { createRouter, createWebHistory } from "vue-router";
import Dashboard from "../view/Dashboard.vue";
import Services from "../view/Services.vue";
import Requests from "../view/Requests.vue";
import NewService from "../view/NewService.vue";
import EditService from "../view/EditService.vue";
import Service from "../view/Service.vue";
import ServicesService from "@/service/ServicesService";
import AxiosAdapter from "@/infra/AxiosAdapter";
import RequestsService from "@/service/RequestsService";
import BannerService from "@/service/BannerService";
import DashboardService from "@/service/DashboardService";
import Logs from "../view/Logs.vue";
import Log from "../view/Log.vue";

export default class RouterBuilder {
	routes: any[];

	constructor (readonly baseUrl: string) {
		this.routes = [
			{ path: '/', redirect: '/dashboard' },
			{ path: '/dashboard', component: Dashboard, meta: { screenName: 'Dashboard' }, props: { bannerService: new BannerService(new AxiosAdapter(), baseUrl), dashboardService: new DashboardService(new AxiosAdapter(), baseUrl) } },
			{ path: '/services', component: Services, meta: { screenName: 'Services' }, props: { servicesService: new ServicesService(new AxiosAdapter(), baseUrl) } },
			{ path: '/services/new', component: NewService, meta: { screenName: 'New Service' }, props: { servicesService: new ServicesService(new AxiosAdapter(), baseUrl) } },
			{ path: '/services/:idService/edit', component: EditService, meta: { screenName: 'Edit Service' }, props: { servicesService: new ServicesService(new AxiosAdapter(), baseUrl) } },
			{ path: '/services/:idService', component: Service, meta: { screenName: 'Service' }, props: { servicesService: new ServicesService(new AxiosAdapter(), baseUrl) } },
			{ path: '/services/:idService/requests', component: Requests, meta: { screenName: 'Requests' }, props: { requestsService: new RequestsService(new AxiosAdapter(), baseUrl) } },
			{ path: '/services/:idService/requests/:idRequest/logs', component: Logs, meta: { screenName: 'Logs' }, props: { requestsService: new RequestsService(new AxiosAdapter(), baseUrl) } },
			{ path: '/services/:idService/requests/:idRequest/logs/:idRequestLog', component: Log, meta: { screenName: 'Log' }, props: { requestsService: new RequestsService(new AxiosAdapter(), baseUrl) } },
			{ path: '/:pathMatch(.*)*', redirect: '/dashboard' }
		];
	}

	build () {
		const router = createRouter({
			history: createWebHistory('/admin/'),
			routes: this.routes,
		});
		return router;
	}
}
